import { render, staticRenderFns } from "./CoreThreshold.vue?vue&type=template&id=2e8509a1&"
import script from "./CoreThreshold.vue?vue&type=script&lang=js&"
export * from "./CoreThreshold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports